// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uejJst{width:20px;height:20px;opacity:0.3}.uejJst.kBNJG8{opacity:1}.NpXehb{width:28px;height:28px;opacity:0.3}.jrb_ef{width:25px;height:25px;opacity:0.3}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triangle": `uejJst`,
	"with-url": `kBNJG8`,
	"withUrl": `kBNJG8`,
	"icon": `NpXehb`,
	"icon-scheduled": `jrb_ef`,
	"iconScheduled": `jrb_ef`
};
export default ___CSS_LOADER_EXPORT___;
